import VTWA_GRADE_IDS from '../../constants/grade-ids';

//

const CMS_GRADE_TARGETS_MAP = new Map([
  ['All', []],
  ['Pre-K', [VTWA_GRADE_IDS.preKindergarten]],
  [
    'Elementary',
    [
      VTWA_GRADE_IDS.kindergarten,
      VTWA_GRADE_IDS['1stGrade'],
      VTWA_GRADE_IDS['2ndGrade'],
      VTWA_GRADE_IDS['3rdGrade'],
      VTWA_GRADE_IDS['4thGrade'],
      VTWA_GRADE_IDS['5thGrade'],
    ],
  ],
  ['Kindergarten', [VTWA_GRADE_IDS.kindergarten]],
  ['1st Grade', [VTWA_GRADE_IDS['1stGrade']]],
  ['2nd Grade', [VTWA_GRADE_IDS['2ndGrade']]],
  ['3rd Grade', [VTWA_GRADE_IDS['3rdGrade']]],
  ['4th Grade', [VTWA_GRADE_IDS['4thGrade']]],
  ['5th Grade', [VTWA_GRADE_IDS['5thGrade']]],
  [
    'Middle School',
    [
      VTWA_GRADE_IDS['6thGrade'],
      VTWA_GRADE_IDS['7thGrade'],
      VTWA_GRADE_IDS['8thGrade'],
      VTWA_GRADE_IDS.middleSchool,
    ],
  ],
  ['6th Grade', [VTWA_GRADE_IDS['6thGrade']]],
  ['7th Grade', [VTWA_GRADE_IDS['7thGrade']]],
  ['8th Grade', [VTWA_GRADE_IDS['8thGrade']]],
  [
    'High School',
    [
      VTWA_GRADE_IDS['9thGrade'],
      VTWA_GRADE_IDS['10thGrade'],
      VTWA_GRADE_IDS['11thGrade'],
      VTWA_GRADE_IDS['12thGrade'],
      VTWA_GRADE_IDS.highSchoolTestPrep,
    ],
  ],
  ['9th Grade', [VTWA_GRADE_IDS['9thGrade']]],
  ['10th Grade', [VTWA_GRADE_IDS['10thGrade']]],
  ['11th Grade', [VTWA_GRADE_IDS['11thGrade'], VTWA_GRADE_IDS.highSchoolTestPrep]],
  ['12th Grade', [VTWA_GRADE_IDS['12thGrade'], VTWA_GRADE_IDS.highSchoolTestPrep]],
  [
    'College',
    [
      VTWA_GRADE_IDS.collegeFreshman,
      VTWA_GRADE_IDS.collegeSophomore,
      VTWA_GRADE_IDS.collegeJunior,
      VTWA_GRADE_IDS.collegeSenior,
      VTWA_GRADE_IDS.graduateTestPrep,
    ],
  ],
  ['Grad', [VTWA_GRADE_IDS.graduateStudent, VTWA_GRADE_IDS.graduateTestPrep]],
  ['Professional', [VTWA_GRADE_IDS.professionalCertifications]],
  ['Adult', [VTWA_GRADE_IDS.adultLearner]],
]);

//

function mapGradeLevelToVtwaGradeIds(gradeTarget) {
  return CMS_GRADE_TARGETS_MAP.get(gradeTarget) || [];
}

// Exports
// -------

export default mapGradeLevelToVtwaGradeIds;
